module.exports = __webpack_public_path__ + "static/img/78035B_1_2_R_20210918_fit.266e03a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/78035B_1_2_R_20210918_fit.png
// module id = ZNEJ
// module chunks = 0